import { gql } from '@apollo/client';

export const GET_AVAILABLE_DRIVERS = gql`
  query GetAvailableDrivers {
    getAvailableDrivers {
      id
      accountId
      name
      phone
      driverLicenseNumber
      vehiclePlate
      isBlacklist
      isOnDuty
      dspId
      verificationStatus
      status
      isEmployed
      __typename
    }
  }
`;